import { useMediaQuery } from '@mui/material'
import React from 'react'
import { FiLogIn } from 'react-icons/fi'
import { Logo } from '../../../../components/Logo/Logo'
import classes from './EmployerHeader.module.css'
import { Link, useHistory, NavLink } from 'react-router-dom'
import SadatJobsNavbar from '../../../../components/MobileNavbar/SadatJobsNavbar'
export const EmployerHeader: React.FC = ()=>{

    const history = useHistory()
    const matches = useMediaQuery('(max-width:1094px)')

    if(matches) return <EmployerMobileHeader doLogout={()=>history.replace('/logout')} />
    else
    return (
    <div className={classes.header}>
        <div className={classes.NavIcon} onClick={()=>history.replace('/logout')}>
            <FiLogIn color='#BBBBBB' size={30}/>
        </div>
        <div style={{flex: 1, display: 'flex', justifyContent: 'center'}}>
        <NavLink to={'/'}>
            <Logo style={{alignSelf: 'center'}} />
        </NavLink>
        
        </div>
    </div>
)}


const EmployerMobileHeader: React.FC<{doLogout: ()=>void}> = ({doLogout})=>{

  return (
    <SadatJobsNavbar>
        <NavbarEmployerContent doLogout={doLogout} />
    </SadatJobsNavbar>
  )
}




const NavbarEmployerContent: React.FC<{doLogout: ()=>void}> = ({doLogout})=>{

    return(
        <React.Fragment>
            <Link to='/' className={classes.navElement}>
                <p className={classes.navText}>الرئيسية</p>
            </Link>
            <Link to='/employer/page' className={classes.navElement}>
                <p className={classes.navText}>صفحة العمل</p>
            </Link>
            <Link to='/employer/jobs' className={classes.navElement}>
                <p className={classes.navText}>ادارة الوظائف</p>
            </Link>
            <Link to='/employer/settings' className={classes.navElement}>
                <p className={classes.navText}>تعديل البيانات</p>
            </Link>
            <Link to='/employer/report' className={classes.navElement}>
                <p className={classes.navText}>الإبلاغ عن مشكلة</p>
            </Link>
            <div className={classes.navElement} onClick={doLogout}>
                <p className={classes.navText}>تسجيل خروج</p>
            </div>
        </React.Fragment>
    )
}